import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import _ from 'underscore';

import { isDefined } from '../../../../../../utils/variables';
import { SubscriptionTopic } from '../../../../../../viewer/messaging/pubsub';
import { useSubscribe } from '../../../../../hooks/use-subscribe';
import { Icon } from '../../../../icon/icon';
import { useAssetsStore } from '../../../state/assets-store';

const PoiVisibilityIcon = () => {
  const { t } = useTranslation();
  const { assets, filterAssetsByType } = useAssetsStore();

  const [poiCategoryVisible, setPoiCategoryVisible] = React.useState(false);

  const throttledUpdatePoiCategoryVisible = _.throttle(
    (uuid: string) => {
      const pois = filterAssetsByType('poi', assets);
      const poi = pois.find((p) => uuid === p.uuid);
      if (!isDefined(poi)) {
        return;
      }

      const allPoisAreVisible = pois.some((p) => !p.visible) === false;
      setPoiCategoryVisible(allPoisAreVisible);
    },
    200,
    { leading: false },
  );

  useSubscribe(SubscriptionTopic.SkyviewAssetVisibilityChanged, (message) => {
    throttledUpdatePoiCategoryVisible(message.assetUuid);
  });

  const togglePoiVisibility = () => {
    const visibleState = !poiCategoryVisible;
    const pois = filterAssetsByType('poi', assets);
    pois.forEach((poi) => poi.toggleVisibility(visibleState));
  };

  return (
    <Component
      fixedWidth={true}
      icon={['fal', poiCategoryVisible ? 'eye' : 'eye-slash']}
      mouseDownStyle={{ opacity: 0.5 }}
      stopPropagationOnClick={true}
      title={poiCategoryVisible ? t('hide', { ns: 'common' }) : t('show', { ns: 'common' })}
      onClick={() => togglePoiVisibility()}
      onHoverStyle={{ icon: ['fad', poiCategoryVisible ? 'eye' : 'eye-slash'] }}
    />
  );
};

const Component = styled(Icon)``;
export { PoiVisibilityIcon };
